<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Flag Clear</span>
       <a class="button waves-effect" (click)="onNoClick()">
        <i class="material-icons button__icon">cancel</i>
        <span class="button__text">Close</span>
      </a>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container">
          <span class="label">Flag Clear Comment <span class="red-text"></span></span>
          
          <textarea rows="10" [(ngModel)]="comment" type="text" placeholder="Flag Comment"  style="width: 450px;"></textarea>

      </div>
  </div>

  <div class="ttmodal__footer" *ngIf="alreadychanged==false">
      <!-- <button class="button button--primary" style="color: white;" (click)="SaveClear()" >Save and Clear Flag</button>
      <button class="button button--primary" style="color: white;"  (click)="SaveLeave()" >Save and Leave Flag</button> -->
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
       <button class="margin" mat-raised-button color="warn" (click)="SaveClear()">
          <i class="material-icons button__icon">save</i><span class="button__text">
            Save and Clear Flag
          </span>
        </button>
        <button mat-raised-button color="warn" (click)="SaveLeave()">
          <i class="material-icons button__icon">save</i><span class="button__text">
            Save and Leave Flag
          </span>
        </button>
  </div>
  <div class="ttmodal__footer" *ngIf="alreadychanged==true">
    <!-- <button class="button button--primary" style="color: white;" (click)="SaveReset()" >Save and Reset Flag</button> -->
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
     <button mat-raised-button color="warn" (click)="SaveReset()">
          <i class="material-icons button__icon">save</i><span class="button__text">
            Save and Reset Flag
          </span>
     </button>
</div>
</div>